import { deviceAccess } from "@cafe/shared";

/** Зарегистрированный терминал (ТЗ 04 §3.3). Токен устройства хранится локально; вход сотрудников — по PIN. */
export type TerminalDevice = { deviceId: string; deviceToken: string; branchId: string; type: string; name: string };

const KEY = "cafe.device";

export function getDevice(): TerminalDevice | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as TerminalDevice) : null;
  } catch {
    return null;
  }
}

export function saveDevice(d: TerminalDevice) {
  localStorage.setItem(KEY, JSON.stringify(d));
}

export function forgetDevice() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Куда открывать устройство без вошедшего сотрудника: экраны (кухня, готовность) работают сами — `/screen`,
 * рабочие места — экран PIN. Нет устройства — null (обычный вход по паролю).
 */
export function deviceEntry(d: TerminalDevice | null = getDevice()): string | null {
  if (!d) return null;
  return deviceAccess(d.type) === "screen" ? "/screen" : "/terminal";
}

/** Рабочий экран после входа по PIN: касса/официант — касса, курьер — его доставки, кухня (вход менеджера) — KDS. */
export function deviceHome(type: string): string {
  return ({ pos: "/pos", waiter: "/pos", courier: "/courier", kds: "/kitchen" } as Record<string, string>)[type] ?? "/";
}
